
import { Trait, TRAIT_CLASS_RANGES } from "@/lib/consts";
import { TeamEffectivenessReportData } from "@/store/admin/adminTypes";
import { TypedVue } from "@/store/types";
import { Component, Prop, Watch } from "vue-property-decorator";
import CandidateTag from "@/components/platform/CandidateTag.vue";

@Component({ components: { CandidateTag } })
export default class ToSModal extends TypedVue {
  @Prop({ default: () => ({}) })
  readonly reportData!: TeamEffectivenessReportData;
  @Prop({ default: () => [] })
  readonly selectedTags!: string[];
  @Prop({ type: Object, default: () => ({}) })
  readonly tagColours!: Record<string, string>;
  @Prop({ default: false })
  startAnimation!: boolean;
  @Prop({ default: () => [true, true, true] }) startCollapseState!: boolean[];
  @Prop({ default: false }) exporting!: boolean;

  @Watch("collapseState")
  onCollapseStateChange(newVal: boolean[]) {
    this.$emit("on-collapse", newVal);
  }

  public teamAlignmentView = -1;
  public traitPriorities = [2, 1, 0];
  public collapseState = this.startCollapseState;

  get filteredTags() {
    return this.selectedTags.filter((t) => t !== "All");
  }

  get availableTagColours(): Record<string, string> {
    return Object.fromEntries(this.selectedTags.map((tag) => [tag, this.tagColours[tag] || "#5c5e6459"]));
  }

  getCompetencyLevel(percent: number) {
    if (percent >= 80) {
      return "high";
    } else if (percent > 60) {
      return "medium-high";
    } else if (percent >= 50) {
      return "medium-low";
    } else {
      return "low";
    }
  }

  getCompetencySummaries(traitPriority: number) {
    return Object.keys(this.reportData?.traitPriorities ?? {})
      .filter((key) => (this.reportData?.traitPriorities[key] ?? 0) === traitPriority)
      .map((key) => {
        const passed = (this.reportData?.assessments ?? []).filter((a) => (a.scoring.trait_scores as any)[key] >= TRAIT_CLASS_RANGES[key as Trait].low).length;
        const percent = Math.round((passed / (this.reportData?.assessments.length ?? 1)) * 100);

        return {
          name: this.$t(`Comparison::TraitChart::XAxisLabel::${key}`).toString(),
          passed,
          percent,
          level: this.getCompetencyLevel(percent),
          key,
        };
      })
      .sort((a, b) => b.passed - a.passed);
  }

  getCompetencySummaryByTag(tag: string, competency: string) {
    const assessments =
      this.reportData?.assessments.filter((a) => {
        const tagList = this.reportData?.tags?.[a.identifier] || [];
        return tagList.includes(tag) || tag === "All";
      }) || [];

    const count = assessments.length;
    const passed = assessments.filter((a) => (a.scoring.trait_scores as any)[competency] >= TRAIT_CLASS_RANGES[competency as Trait].low).length;
    const percent = Math.round((passed / (assessments.length ?? 1)) * 100);

    return {
      name: this.$t(`Comparison::TraitChart::XAxisLabel::${competency}`).toString(),
      count,
      passed,
      percent,
      level: percent > 80 ? "high" : percent > 21 ? "medium" : "low",
    };
  }

  toggleCollapse(index: number) {
    this.$set(this.collapseState, index, !this.collapseState[index]);
  }
}
